import {
  USER_LOADED,
  USER_LOADING,
  AUTH_ERROR,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  REGISTER_FAIL,
  REGISTER_SUCCESS,
  CHANGE_PASSWORD_SUCCESS,
  DELETE_USER_SUCCESS,
  CHANGE_PASSWORD_EMAIL_SEND_SUCCESS,
  RESET_PASSWORD_SUCCESS,
} from "../actions/types";

const initialState = {
  token: localStorage.getItem("adventureToken"),
  isAuthenticated: null,
  isLoading: false,
  user: null,
  passwordReset: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        user: action.payload,
      };
    case LOGIN_SUCCESS:
    case REGISTER_SUCCESS:
      localStorage.setItem("adventureToken", action.payload.token);
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        isLoading: false,
      };
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT_SUCCESS:
    case REGISTER_FAIL:
    case CHANGE_PASSWORD_SUCCESS:
    case DELETE_USER_SUCCESS:
    case RESET_PASSWORD_SUCCESS:
      localStorage.removeItem("adventureToken");
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        isLoading: false,
      };
    case CHANGE_PASSWORD_EMAIL_SEND_SUCCESS:
      return {
        ...state,
      };
    default:
      return state;
  }
}
